import { API, graphqlOperation } from 'aws-amplify'

export const getData = async function (_date, _queryText) {
  const queryText = _queryText.replace('$date', `"${_date}"`)
  //   console.log('queryText', queryText)
  try {
    const res = await API.graphql(graphqlOperation(queryText))
    // console.log('getDatafromDB >>>', res.data)
    return res.data
    // const { data } = await axios({
    //   url: 'https://p2ha77gfjzhl7nbjoiwolwmleu.appsync-api.ap-southeast-1.amazonaws.com/graphql',
    //   method: 'post',
    //   headers: {
    //     'x-api-key': 'da2-dnzqionk6jc7fjd5ieqfehqz54',
    //     'Content-Type': 'application/json'
    //   },
    //   data: JSON.stringify({ query: queryText })
    // })
    // console.log(data.data)
    // return data.data
  } catch (error) {
    console.log(error)
  }
}
